// Utilitaires de formatage FR — dates, temps relatifs.
const MONTHS_FR = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];

export const formatFrDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.getDate()} ${MONTHS_FR[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatFrDayMonth = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()} ${MONTHS_FR[d.getMonth()].slice(0, 4)}`;
};

export const formatRelative = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diffMs = Date.now() - d.getTime();
  const m = Math.floor(diffMs / 60000);
  if (m < 1) return "à l'instant";
  if (m < 60) return `il y a ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `il y a ${h} h`;
  const days = Math.floor(h / 24);
  if (days < 30) return `il y a ${days} j`;
  return formatFrDate(iso);
};

export const formatTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
};

// Regroupe les messages par jour lisible : "Aujourd'hui", "Hier", "Mardi 12 février"
export const groupMessagesByDay = (messages = []) => {
  const groups = new Map();
  const days = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  for (const m of messages) {
    const d = new Date(m.created_at);
    if (Number.isNaN(d.getTime())) continue;
    const key = d.toISOString().slice(0, 10);
    const midnight = new Date(d);
    midnight.setHours(0, 0, 0, 0);

    let label;
    if (midnight.getTime() === today.getTime()) label = "Aujourd'hui";
    else if (midnight.getTime() === yesterday.getTime()) label = "Hier";
    else label = `${days[d.getDay()]} ${d.getDate()} ${MONTHS_FR[d.getMonth()]}`;

    if (!groups.has(key)) groups.set(key, { id: key, day: label, items: [] });
    groups.get(key).items.push({
      id: m.id,
      from: m.from_side,
      author: m.author,
      time: formatTime(m.created_at),
      text: m.text,
      attachment: m.attachment,
    });
  }
  return Array.from(groups.values());
};
